import { createFileRoute } from "@tanstack/react-router";
import type { TemplateId } from "../../convex/templateTypes";
import { TEMPLATE_IDS } from "../../convex/templateTypes";

import SiteBuilderFlow from "../components/builder/SiteBuilderFlow";
import LandingLayout from "../components/LandingLayout";
import {
  DEFAULT_TEMPLATE_PREVIEW_PALETTE_ID,
  isTemplatePreviewPaletteId,
} from "../lib/templatePalettes";

export const Route = createFileRoute("/create")({
  component: CreatePage,
  validateSearch: (search: Record<string, unknown>) => {
    const template =
      typeof search.template === "string" &&
      (TEMPLATE_IDS as readonly string[]).includes(search.template)
        ? (search.template as TemplateId)
        : undefined;
    const palette =
      typeof search.palette === "string" &&
      isTemplatePreviewPaletteId(search.palette)
        ? search.palette
        : undefined;

    return {
      ...(palette ? { palette } : {}),
      step: search.step === "details" && template ? "details" : undefined,
      template,
    };
  },
});

function CreatePage() {
  const search = Route.useSearch();

  return (
    <LandingLayout>
      <SiteBuilderFlow
        initialPaletteId={
          search.template
            ? (search.palette ?? DEFAULT_TEMPLATE_PREVIEW_PALETTE_ID)
            : DEFAULT_TEMPLATE_PREVIEW_PALETTE_ID
        }
        initialStep={search.step === "details" ? "details" : "template"}
        initialTemplateId={search.template ?? null}
      />
    </LandingLayout>
  );
}
